import { getModifiedPageData, getPageHtmlToSave, getAccessiblePageHtmlToSave } from './html';
import { getParsedCss } from './css';
import {
	getCssWithUpdatedThemeColor,
	getCssWithUpdatedThemes,
	getThemesAndSelectedThemeId,
	getCssWithDuplicatedTheme,
	getCssWithoutRemovedTheme,
	getCssWithRenamedTheme,
} from './themesCss';
import { getModifiedScripts } from './scripts';

export default {
	getModifiedPageData,
	getPageHtmlToSave,
	getParsedCss,
	getThemesAndSelectedThemeId,
	getCssWithUpdatedThemes,
	getCssWithDuplicatedTheme,
	getCssWithoutRemovedTheme,
	getCssWithRenamedTheme,
	getCssWithUpdatedThemeColor,
	getModifiedScripts,
	getAccessiblePageHtmlToSave,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/index.ts